import { Type, type Static } from "@sinclair/typebox";

const strict = { additionalProperties: false } as const;
const uuid = Type.String({ format: "uuid" });
const local = Type.String({ pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}$" });
export const PersonalAgendaWindowSchema = Type.Object(
  {
    from: Type.String({ format: "date" }),
    to: Type.String({ format: "date" }),
  },
  strict,
);
export const PersonalEventFieldsSchema = Type.Object(
  {
    title: Type.String({ minLength: 1, maxLength: 240, pattern: "\\S" }),
    startLocal: local,
    endLocal: local,
    allDay: Type.Boolean(),
    place: Type.String({ maxLength: 500 }),
    note: Type.String({ maxLength: 4000 }),
  },
  strict,
);
export type PersonalEventFields = Static<typeof PersonalEventFieldsSchema>;
export const PersonalTaskFieldsSchema = Type.Object(
  {
    title: Type.String({ minLength: 1, maxLength: 240, pattern: "\\S" }),
    note: Type.String({ maxLength: 4000 }),
    list: Type.String({ minLength: 1, maxLength: 80, pattern: "\\S" }),
    dueOn: Type.Union([Type.String({ format: "date" }), Type.Null()]),
    starred: Type.Boolean(),
    completed: Type.Boolean(),
    taskKind: Type.Optional(
      Type.Union([Type.Literal("activity"), Type.Literal("todo")]),
    ),
    estimatedHours: Type.Optional(Type.Integer({ minimum: 1, maximum: 800 })),
    plan: Type.Optional(
      Type.Union([
        Type.Null(),
        Type.Object(
          {
            day: Type.String({ format: "date" }),
            slot: Type.Integer({ minimum: 0, maximum: 7 }),
          },
          strict,
        ),
      ]),
    ),
  },
  strict,
);
export type PersonalTaskFields = Static<typeof PersonalTaskFieldsSchema>;
export const PersonalAgendaChangeSchema = Type.Union([
  Type.Object(
    {
      kind: Type.Literal("agenda.event.save"),
      id: uuid,
      version: Type.Integer({ minimum: 0 }),
      fields: PersonalEventFieldsSchema,
    },
    strict,
  ),
  Type.Object(
    {
      kind: Type.Literal("agenda.task.save"),
      id: uuid,
      version: Type.Integer({ minimum: 0 }),
      fields: PersonalTaskFieldsSchema,
    },
    strict,
  ),
  Type.Object(
    {
      kind: Type.Literal("agenda.event.delete"),
      id: uuid,
      version: Type.Integer({ minimum: 1 }),
    },
    strict,
  ),
  Type.Object(
    {
      kind: Type.Literal("agenda.task.delete"),
      id: uuid,
      version: Type.Integer({ minimum: 1 }),
    },
    strict,
  ),
]);
export type PersonalAgendaChange = Static<typeof PersonalAgendaChangeSchema>;
export const PersonalAgendaWriteSchema = Type.Object(
  {
    operationId: uuid,
    change: PersonalAgendaChangeSchema,
  },
  strict,
);
export interface PersonalEvent extends PersonalEventFields {
  id: string;
  version: number;
  startsAt: string;
  endsAt: string;
}
export interface PersonalTask extends PersonalTaskFields {
  id: string;
  version: number;
  createdAt?: string;
}
export interface PersonalAgendaOverview {
  events: PersonalEvent[];
  tasks: PersonalTask[];
}
